import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { primary, gutterXs } from '../../style/variables';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { focusColor } from '../../style/variables';

export const Tout = styled(ToutContent)(
  ({ theme, hasBackground }) => `
  position: absolute;
  z-index: 101;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${gutterXs};
  background: ${
    hasBackground ? 'linear-gradient(0deg, rgba(0, 0, 0, 0.8) 30%, rgba(0, 0, 0, 0) 80%)' : ''
  };
  ${theme.breakpoints.down('md')} {
    display: none;
  },
  ${theme.breakpoints.up('lg')} {
    padding: 3.5rem;
  },
`,
);

export const SliderHeadings = styled(Typography)(
  ({ theme }) => `
  font-size: 1.25rem;
  line-height: 1.125rem;
  color: ${primary};
  letter-spacing: 1px;
  ${theme.breakpoints.down('md')} {
    display: none;
  },
`,
);

export const BottomContent = styled('div')(
  ({ theme }) => `
  display: none;
  padding: ${gutterXs} 100px;
  width: 100%;
  background: none !important;
  ${theme.breakpoints.down('md')} {
    display: block;
  };
  ${theme.breakpoints.down('sm')} {
    padding-left: 25px;
    padding-right: 25px;
  },
`,
);

export const Divider = styled('div')(
  ({ theme }) => `
  content: "";
  height: .25rem;
  width: 100%;
  display: block;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  background-color: ${primary};
  ${theme.breakpoints.up('md')} {
    margin-bottom: 8px;
  },
`,
);

interface Props {
  lightArrow?: boolean;
}

export const CarouselWrapper = styled('div')<Props>(
  ({ theme }) => `
    .slick-slide {
      filter: grayscale(1);
      opacity: 0.2;
      transform: scale(0.95);
      border-radius: unset;
      transition: all 0.5s;
    }
    .slick-slide > div > div > div {
      opacity: 0;
    }
    .slick-current {
      filter: none;
      opacity: 1;
      transform: scale(1);
    }
    .slick-slide:focus, .slick-slide:focus-within {
      filter: none;
      opacity: 1;
      transition: all 0.5s;
    }
    .slick-current > div > div > div {
      opacity: 1;
    }
    .slick-prev {
      left: 80px;
      margin-bottom: 150px;
      display: inline-block;
      z-index: 10;
    }
    .slick-next {
      right: 100px;
      margin-bottom: 150px; 
      display: inline-block;
      z-index: 10;
    }
    .slick-prev:focus, .slick-next:focus {
      outline: 3px solid ${focusColor};
    }
    .slick-track {
      display: flex;
      align-items: center;
    }
    .slick-dots {
      display: block !important;
    }
    .slick-dots li {
      width: unset;
      height: unset;
      flex: 1;
      filter: grayscale(1);
      display: flex;
      align-items: flex-start;
    }
    .slick-dots li:first-child {
      margin-left: 0px;
    }
    .slick-dots li:last-child {
      margin-right: 0px;
    }
    .slick-dots .slick-active {
      filter: grayscale(0);
    }
    .slick-dots li:hover {
      filter: grayscale(0);
    }
    .slick-dots ul {
      margin: 0px;
      display: flex;
      padding-left: 0px;
    }
    .slick-dots {
      text-align: left;
      width: 100%;
      padding-top: 1rem;
      padding-left: 180px;
      padding-right: 180px;

      ${theme.breakpoints.down('md')} {
        padding-left: 100px;
        padding-right: 100px;
        padding-top: 0;
      }

      ${theme.breakpoints.down('sm')}  {
        padding-left: 25px;
        padding-right: 25px;
      }
    }
    .slick-dots button {
      all: unset !important;
    }
    .slick-dots li button {
      flex: 1 !important;
    }
    .slick-dots li button:focus-visible {
      outline: 3px solid ${focusColor} !important;
    }
    .slick-dots li button:before {
      all: unset !important;
    }
    .slick-dots li.slick-active button {
      border: none !important;
      background-color: unset !important;
    }
    .slick-dots li.slick-active button:before {
      all: unset !important;
    }
  }
`,
);
